import { forwardRef } from "react";
import { AutocompleteRenderInputParams } from "@mui/material/Autocomplete";

import TextField from "features/components/TextField";
import { SelectOption } from "features/ui/Select";

interface Props extends AutocompleteRenderInputParams {
  selectedValues: SelectOption[];
  placeholder?: string;
  hideInput?: boolean;
}

export const CustomInput = forwardRef<HTMLDivElement, Props>(
  function CustomInput(params, ref) {
    const { selectedValues, placeholder, slotProps, ...textFieldProps } =
      params;

    return (
      <TextField
        {...textFieldProps}
        ref={ref}
        placeholder={selectedValues.length > 0 ? "" : placeholder}
        slotProps={{
          ...slotProps,
          input: {
            ...slotProps.input,
            readOnly: true,
          },
        }}
        sx={{
          // readOnly select-style input: the whole box opens the menu, so show
          // the pointer across it. Target the InputBase root, which MUI defaults
          // to cursor:text — that beats an inherited cursor on the outer root.
          "& .MuiInputBase-root": { cursor: "pointer" },
          "& input": {
            cursor: "pointer",
            caretColor: "transparent",
          },
          "& input::placeholder": {
            opacity: 1,
          },
        }}
        onKeyDown={(e) => {
          // Prevent typing values in the input
          e.preventDefault();
        }}
      />
    );
  }
);
